/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { Link } from "react-router-dom";
import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";
import Typography from "components/generals/Typography";
import Card from "components/generals/Card";
import Box from "components/generals/Box";
import { useTranslation } from "react-i18next";

/**
 * Unauthorized access error page.
 * 
 * Displayed when a user attempts to access a resource or page without
 * the required permissions. This page is shown by PrivateRoute components
 * when permission checks fail.
 * 
 * Features:
 * - Clear "Access Denied" message with i18n support
 * - Wrapped in DefaultDashboardLayout to maintain navigation
 * - User can navigate back using sidebar or browser back button
 * 
 * This page is part of the role-based access control (RBAC) system
 * enforcing ISO-27001 compliant access restrictions.
 * 
 * @returns Unauthorized page component
 */
const Unauthorized: React.FC = () => {
  const { t } = useTranslation();

  return (
    <DefaultDashboardLayout>
      <Box borderRadius="lg" ml={2} mt={2} width="calc(100% - 2rem)" height="calc(100% - 2rem)">
        <Card>
          <Box p={2}>
            <Typography variant="h2">{t("Unauthorized.accessDenied")}</Typography>
            <Typography variant="caption" color="text" fontWeight="medium">
              {t("Unauthorized.accessDeniedMessage")}
            </Typography>
          </Box>
        </Card>
      </Box>
    </DefaultDashboardLayout>
  );
};

export default Unauthorized;

